import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectAllMessages } from "../services/alertMessagesSlice";

export const useAlertMessages = () => {
    const alertMessages = useSelector(selectAllMessages);

    return useMemo(() => ({ alertMessages }), [alertMessages]);
};
